import { BCMSAsset } from "bcms-react";

// SVG Imports
import { ReactComponent as ArrowDownIcon } from "res/img/ArrowDownIcon.svg";
import { ReactComponent as BankIcon } from "res/img/BankIcon.svg";
import { ReactComponent as CheckPenIcon } from "res/img/CheckPenIcon.svg";
import { ReactComponent as CheckmarkBadgeIcon } from "res/img/CheckmarkBadgeIcon.svg";
import { ReactComponent as CircleDollarSignIcon } from "res/img/CircleDollarSignIcon.svg";
import { ReactComponent as ClockIcon } from "res/img/ClockIcon.svg";
import { ReactComponent as ClockArrowIcon } from "res/img/ClockArrowIcon.svg";
import { ReactComponent as ConfirmIcon } from "res/img/ConfirmIcon.svg";
import { ReactComponent as DocumentIcon } from "res/img/DocumentIcon.svg";
import { ReactComponent as DragDropIcon } from "res/img/DragDropIcon.svg";
import { ReactComponent as EditIcon } from "res/img/EditIcon.svg";
import { ReactComponent as EllipsisIcon } from "res/img/EllipsisIcon.svg";
import { ReactComponent as EnvelopeIcon } from "res/img/EnvelopeIcon.svg";
import { ReactComponent as EyeIcon } from "res/img/EyeIcon.svg";
import { ReactComponent as HeadsetIcon } from "res/img/HeadsetIcon.svg";
import { ReactComponent as HideEyeIcon } from "res/img/HideEyeIcon.svg";
import { ReactComponent as KeyIcon } from "res/img/KeyIcon.svg";
import { ReactComponent as LeftArrowIcon } from "res/img/LeftArrowIcon.svg";
import { ReactComponent as ListIcon } from "res/img/ListIcon.svg";
import { ReactComponent as LocationPinIcon } from "res/img/LocationPinIcon.svg";
import { ReactComponent as MinusMagnifyingGlassIcon } from "res/img/MinusMagnifyingGlassIcon.svg";
import { ReactComponent as MobilePhoneIcon } from "res/img/MobilePhoneIcon.svg";
import { ReactComponent as PencilIcon } from "res/img/PencilIcon.svg";
import { ReactComponent as PiggyBankDollarSignIcon } from "res/img/PiggyBankDollarSignIcon.svg";
import { ReactComponent as PiggyBankIcon } from "res/img/PiggyBankIcon.svg";
import { ReactComponent as PlusIcon } from "res/img/PlusIcon.svg";
import { ReactComponent as PlusMagnifyingGlassIcon } from "res/img/PlusMagnifyingGlassIcon.svg";
import { ReactComponent as ProfileIcon } from "res/img/ProfileIcon.svg";
import { ReactComponent as QuestionMarkCircleIcon } from "res/img/QuestionMarkCircleIcon.svg";
import { ReactComponent as ShareIcon } from "res/img/ShareIcon.svg";
import { ReactComponent as SilentBellIcon } from "res/img/SilentBellIcon.svg";
import { ReactComponent as SortIcon } from "res/img/SortIcon.svg";
import { ReactComponent as SquareMessageBubbleIcon } from "res/img/SquareMessageBubbleIcon.svg";
import { ReactComponent as SquareProfileIcon } from "res/img/SquareProfileIcon.svg";
import { ReactComponent as TrashcanXIcon } from "res/img/TrashcanXIcon.svg";
import { ReactComponent as WiresIcon } from "res/img/WiresIcon.svg";
import { ReactComponent as AlertTriangleIcon } from "res/img/alert-triangle-icon.svg";
import { ReactComponent as ArrowUpIcon } from "res/img/arrow-up-icon.svg";
import { ReactComponent as BarChartIcon } from "res/img/bar-chart-icon.svg";
import { ReactComponent as BellIcon } from "res/img/bell-icon.svg";
import { ReactComponent as CalendarIcon } from "res/img/calendar-icon.svg";
import { ReactComponent as CameraIcon } from "res/img/camera-icon.svg";
import { ReactComponent as CardIcon } from "res/img/card-icon.svg";
import { ReactComponent as ChatIcon } from "res/img/chat-icon.svg";
import { ReactComponent as CheckListIcon } from "res/img/check-list-icon.svg";
import { ReactComponent as CircleCheckmarkIcon } from "res/img/circle-checkmark-icon.svg";
import { ReactComponent as CircleProfileIcon } from "res/img/circle-profile-icon.svg";
import { ReactComponent as CircleQuestionMarkIcon } from "res/img/circle-question-mark-icon.svg";
import { ReactComponent as CloseX } from "res/img/close-x.svg";
import { ReactComponent as CopyIcon } from "res/img/copy-icon.svg";
import { ReactComponent as DollarSignOutlineIcon } from "res/img/dollar-sign-outline-icon.svg";
import { ReactComponent as DownChevronIcon } from "res/img/down-chevron-icon.svg";
import { ReactComponent as DownloadArrowIcon } from "res/img/download-arrow-icon.svg";
import { ReactComponent as DropdownIcon } from "res/img/dropdown-icon.svg";
import { ReactComponent as EqualHousing } from "res/img/equal-housing.svg";
import { ReactComponent as GearIcon } from "res/img/gear-icon.svg";
import { ReactComponent as GearOutlineIcon } from "res/img/gear-outline-icon.svg";
import { ReactComponent as HamburgerMenuIcon } from "res/img/hamburger-menu-icon.svg";
import { ReactComponent as HouseIcon } from "res/img/house-icon.svg";
import { ReactComponent as InfoIcon } from "res/img/info-icon.svg";
import { ReactComponent as KeypadButtonsIcon } from "res/img/keypad-buttons-icon.svg";
import { ReactComponent as LeftChevronIcon } from "res/img/left-chevron-icon.svg";
import { ReactComponent as LeftDoubleChevronIcon } from "res/img/left-double-chevron-icon.svg";
import { ReactComponent as MagnifyingGlassIcon } from "res/img/magnifying-glass-icon.svg";
import { ReactComponent as MessageBubbleIcon } from "res/img/message-bubble-icon.svg";
import { ReactComponent as MonitorIcon } from "res/img/monitor-icon.svg";
import { ReactComponent as MuteIcon } from "res/img/mute-icon.svg";
import { ReactComponent as OpenDoorIcon } from "res/img/open-door-icon.svg";
import { ReactComponent as PaperclipIcon } from "res/img/paperclip-icon.svg";
import { ReactComponent as PhoneIcon } from "res/img/phone-icon.svg";
import { ReactComponent as QuestionMarkMessageIcon } from "res/img/question-mark-message-icon.svg";
import { ReactComponent as RightChevronIcon } from "res/img/right-chevron-icon.svg";
import { ReactComponent as RightDoubleChevronIcon } from "res/img/right-double-chevron-icon.svg";
import { ReactComponent as SendArrowIcon } from "res/img/send-arrow-icon.svg";
import { ReactComponent as TransfersIcon } from "res/img/transfers-icon.svg";
import { ReactComponent as UpChevronIcon } from "res/img/up-chevron-icon.svg";
import { ReactComponent as VideoCameraIcon } from "res/img/video-camera-icon.svg";
import { ReactComponent as WalletIcon } from "res/img/wallet-icon.svg";
import { ReactComponent as XMessageBubbleIcon } from "res/img/x-message-bubble-icon.svg";
import { ReactComponent as ZelleIcon } from "res/img/zelle-icon.svg";

// IMG Imports
import SignOutIcon from "res/img/SignOutIcon.png";
import CheckBackEndorsed from "res/img/check-back-endorsed.png";
import CheckBack from "res/img/check-back.png";
import CheckFrontFilledOut from "res/img/check-front-filled-out.png";
import CheckFront from "res/img/check-front.png";
import CreditScoreImage from "res/img/credit-score-image.png";
import MobileUltraLogo from "res/img/mobile-ultra-logo.png";
import MyFinancialLogoWhite from "res/img/myFinancialLogo-white.png";
import NationalCreditIconLogoGraph from "res/img/national-credit-icon-logo-graph.png";
import SampleStatement from "res/img/sample-statement.png";
import SuperFinancialLogoGrey from "res/img/super-financial-logo-grey.png";
import TelecomSquareLogo from "res/img/telecom-square-logo.png";
import FDICDigitalSignWhite from "res/img/fdic-digital-sign-white.png";
import FDICDigitalSign from "res/img/fdic-digital-sign.png";

const { image, svg } = BCMSAsset.init({
	// SVG Exports
	"ArrowDownIcon" : ArrowDownIcon,
	"BankIcon" : BankIcon,
	"CheckPenIcon" : CheckPenIcon,
	"CheckmarkBadgeIcon" : CheckmarkBadgeIcon,
	"CircleDollarSignIcon" : CircleDollarSignIcon,
	"ClockIcon" : ClockIcon,
	"ClockArrowIcon" : ClockArrowIcon,
	"ConfirmIcon" : ConfirmIcon,
	"DocumentIcon" : DocumentIcon,
	"DragDropIcon" : DragDropIcon,
	"EditIcon" : EditIcon,
	"EllipsisIcon" : EllipsisIcon,
	"EnvelopeIcon" : EnvelopeIcon,
	"EyeIcon" : EyeIcon,
	"HeadsetIcon" : HeadsetIcon,
	"HideEyeIcon" : HideEyeIcon,
	"KeyIcon" : KeyIcon,
	"LeftArrowIcon" : LeftArrowIcon,
	"ListIcon" : ListIcon,
	"LocationPinIcon" : LocationPinIcon,
	"MinusMagnifyingGlassIcon" : MinusMagnifyingGlassIcon,
	"MobilePhoneIcon" : MobilePhoneIcon,
	"PencilIcon" : PencilIcon,
	"PiggyBankDollarSignIcon" : PiggyBankDollarSignIcon,
	"PiggyBankIcon" : PiggyBankIcon,
	"PlusIcon" : PlusIcon,
	"PlusMagnifyingGlassIcon" : PlusMagnifyingGlassIcon,
	"ProfileIcon" : ProfileIcon,
	"QuestionMarkCircleIcon" : QuestionMarkCircleIcon,
	"ShareIcon" : ShareIcon,
	"SilentBellIcon" : SilentBellIcon,
	"SortIcon" : SortIcon,
	"SquareMessageBubbleIcon" : SquareMessageBubbleIcon,
	"SquareProfileIcon" : SquareProfileIcon,
	"TrashcanXIcon" : TrashcanXIcon,
	"WiresIcon" : WiresIcon,
	"AlertTriangleIcon" : AlertTriangleIcon,
	"ArrowUpIcon" : ArrowUpIcon,
	"BarChartIcon" : BarChartIcon,
	"BellIcon" : BellIcon,
	"CalendarIcon" : CalendarIcon,
	"CameraIcon" : CameraIcon,
	"CardIcon" : CardIcon,
	"ChatIcon" : ChatIcon,
	"CheckListIcon" : CheckListIcon,
	"CircleCheckmarkIcon" : CircleCheckmarkIcon,
	"CircleProfileIcon" : CircleProfileIcon,
	"CircleQuestionMarkIcon" : CircleQuestionMarkIcon,
	"CloseX" : CloseX,
	"CopyIcon" : CopyIcon,
	"DollarSignOutlineIcon" : DollarSignOutlineIcon,
	"DownChevronIcon" : DownChevronIcon,
	"DownloadArrowIcon" : DownloadArrowIcon,
	"DropdownIcon" : DropdownIcon,
	"EqualHousing" : EqualHousing,
	"GearIcon" : GearIcon,
	"GearOutlineIcon" : GearOutlineIcon,
	"HamburgerMenuIcon" : HamburgerMenuIcon,
	"HouseIcon" : HouseIcon,
	"InfoIcon" : InfoIcon,
	"KeypadButtonsIcon" : KeypadButtonsIcon,
	"LeftChevronIcon" : LeftChevronIcon,
	"LeftDoubleChevronIcon" : LeftDoubleChevronIcon,
	"MagnifyingGlassIcon" : MagnifyingGlassIcon,
	"MessageBubbleIcon" : MessageBubbleIcon,
	"MonitorIcon" : MonitorIcon,
	"MuteIcon" : MuteIcon,
	"OpenDoorIcon" : OpenDoorIcon,
	"PaperclipIcon" : PaperclipIcon,
	"PhoneIcon" : PhoneIcon,
	"QuestionMarkMessageIcon" : QuestionMarkMessageIcon,
	"RightChevronIcon" : RightChevronIcon,
	"RightDoubleChevronIcon" : RightDoubleChevronIcon,
	"SendArrowIcon" : SendArrowIcon,
	"TransfersIcon" : TransfersIcon,
	"UpChevronIcon" : UpChevronIcon,
	"VideoCameraIcon" : VideoCameraIcon,
	"WalletIcon" : WalletIcon,
	"XMessageBubbleIcon" : XMessageBubbleIcon,
	"ZelleIcon" : ZelleIcon,

	// IMG Exports
	"SignOutIcon" : SignOutIcon,
	"CheckBackEndorsed" : CheckBackEndorsed,
	"CheckBack" : CheckBack,
	"CheckFrontFilledOut" : CheckFrontFilledOut,
	"CheckFront" : CheckFront,
	"CreditScoreImage" : CreditScoreImage,
	"MobileUltraLogo" : MobileUltraLogo,
	"MyFinancialLogoWhite" : MyFinancialLogoWhite,
	"NationalCreditIconLogoGraph" : NationalCreditIconLogoGraph,
	"SampleStatement" : SampleStatement,
	"SuperFinancialLogoGrey" : SuperFinancialLogoGrey,
	"TelecomSquareLogo" : TelecomSquareLogo,
	"FDICDigitalSignWhite" : FDICDigitalSignWhite,
	"FDICDigitalSign" : FDICDigitalSign
}).loadAsset();

// Export a function for images
export function ImageAsset(props){ 
	return (<> { image(props.id, props) } </>); 
}

// Export a function for svgs
export function SVGAsset(props){ 
	return (<> { svg(props.id, { ...props, className: `${ props.className ?? "" } icon` }) } </>); 
}